/* eslint-disable react-refresh/only-export-components */
import {
  createContext,
  useContext,
  useEffect,
  useState,
  type ReactNode,
} from 'react'

// Lets a detail page label its `:id` breadcrumb crumb with the real entity name
// (client name, invoice number, …) instead of the generic "Detail" fallback.
interface BreadcrumbContextValue {
  label: string | null
  setLabel: (label: string | null) => void
}

const BreadcrumbContext = createContext<BreadcrumbContextValue | null>(null)

export function BreadcrumbProvider({ children }: { children: ReactNode }) {
  const [label, setLabel] = useState<string | null>(null)
  return (
    <BreadcrumbContext.Provider value={{ label, setLabel }}>
      {children}
    </BreadcrumbContext.Provider>
  )
}

// Read the current dynamic label (consumed by the breadcrumb renderer).
export function useBreadcrumbLabelValue(): string | null {
  return useContext(BreadcrumbContext)?.label ?? null
}

// Set the dynamic detail label for the active route. Pass the entity name (or
// undefined while loading). Clears automatically on unmount / navigation.
export function useBreadcrumbLabel(label: string | null | undefined) {
  const ctx = useContext(BreadcrumbContext)
  const setLabel = ctx?.setLabel
  useEffect(() => {
    if (!setLabel) return
    setLabel(label ?? null)
    return () => setLabel(null)
  }, [setLabel, label])
}
